module.exports = __webpack_public_path__ + "static/media/black-x.c96deac2.svg";